<ul class="accordion navbar-nav" aria-expanded="true" id="accordionHeaderSidebar">
   <!-- Trang chủ -->
   <li class="nav-item no-arrow">
      <a class="nav-link" href="javascript:void(0)" [routerLink]="enterpriseRouter[0].link"
         [ngClass]=" (currentLink == enterpriseRouter[0].link) ? 'active' : '' ">
         <i class="fa fa-home fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
         <span>{{'header.home' | translate}}</span>
      </a>
   </li>

   <!-- Quản lý hợp đồng -->
   <li class="nav-item no-arrow"
      *ngIf="getAccessRights(enterpriseRouter[1].link) || getAccessRights(enterpriseRouter[2].link)  || getAccessRights(enterpriseRouter[27].link) || getAccessRights(enterpriseRouter[48].link) || getAccessRights(enterpriseRouter[44].link)">
      <a id="menuDocumentManage" (click)="onMenuClick('menuDocumentManage')" class="nav-link collapsed"
         href="javascript:void(0)" data-toggle="collapse" data-target="#collapseDocuments" aria-expanded="true"
         aria-controls="collapseDocuments"
         [ngClass]=" (currentLink == enterpriseRouter[1].link || currentLink == enterpriseRouter[2].link || currentLink === enterpriseRouter[27].link || currentLink === enterpriseRouter[48].link  || currentLink === enterpriseRouter[44].link) ? 'active' : '' ">
         <i class="fa fa-file-text-o fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
         <span>{{'breadcrumbs.document_breadcrumbs'| translate}}</span>
      </a>
      <div id="collapseDocuments" class="collapse prioritize-submenu" aria-labelledby="headingPages"
         data-parent="#accordionHeaderSidebar">
         <div class="collapse-inner rounded">
            <a [ngClass]=" (currentLink === enterpriseRouter[1].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[1].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[1].link">{{'left_menu.enterprise_create_doccument' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[2].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[2].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[2].link">{{'left_menu.enterprise_rece_doc' | translate}}</a>

           <a [ngClass]=" (currentLink === enterpriseRouter[37].link) ? 'highlight' : '' " tabindex="0"
              *ngIf="getAccessRights(enterpriseRouter[37].link)" class="collapse-item"
              [routerLink]="enterpriseRouter[37].link">{{'left_menu.enterprise_digitization_business' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[44].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[44].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[44].link">{{'contract_share_partner.breadcrumb' |translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[48].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[48].link)  && entType == '1'" class="collapse-item"
               [routerLink]="enterpriseRouter[48].link">{{'contract_share_partner.contract-company' |translate}}</a>
         </div>
      </div>
   </li>

   <!-- Hợp đồng của tôi -->
   <li class="nav-item no-arrow" *ngIf="getAccessRights(enterpriseRouter[4].link) || getAccessRights(enterpriseRouter[5].link) || getAccessRights(enterpriseRouter[6].link)
          || getAccessRights(enterpriseRouter[7].link) || getAccessRights(enterpriseRouter[8].link) || getAccessRights(enterpriseRouter[29].link) || getAccessRights(enterpriseRouter[43].link) || getAccessRights(enterpriseRouter[42].link)">
      <a id="menuMyDocument" (click)="onMenuClick('menuMyDocument')" class="nav-link collapsed"
         href="javascript:void(0)" data-toggle="collapse" data-target="#collapseMyDocuments" aria-expanded="true"
         aria-controls="collapseMyDocuments" [ngClass]=" (currentLink == enterpriseRouter[4].link || currentLink == enterpriseRouter[5].link || currentLink == enterpriseRouter[6].link
          || currentLink == enterpriseRouter[7].link || currentLink == enterpriseRouter[8].link || currentLink == enterpriseRouter[29].link || currentLink == enterpriseRouter[43].link || currentLink == enterpriseRouter[42].link) ? 'active' : '' ">
         <i class="fa fa-folder-open-o fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
         <span>{{'breadcrumbs.my_documents'| translate}} </span>
      </a>
      <div id="collapseMyDocuments" class="collapse prioritize-submenu" aria-labelledby="headingPages"
         data-parent="#accordionHeaderSidebar">
         <div class="collapse-inner rounded">
            <a [ngClass]=" (currentLink == enterpriseRouter[4].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[4].link)" class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[4].link">
               {{'left_menu.enterprise_create_doc' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[5].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[5].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[5].link">
            {{'left_menu.enterprise_my_created_doc' | translate}}</a>            
           <a [ngClass]=" (currentLink === enterpriseRouter[27].link) ? 'highlight' : '' " tabindex="0"
              *ngIf="getAccessRights(enterpriseRouter[27].link)" class="collapse-item"
              [routerLink]="enterpriseRouter[27].link">
             {{'left_menu.enterprise_my_receive_doc' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[6].link) ? 'highlight' : '' " tabindex="0"
               class="collapse-item" [routerLink]="enterpriseRouter[6].link">
               {{'left_menu.enterprise_waiting_signing_doc' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[7].link) ? 'highlight' : '' " tabindex="0"
               class="collapse-item" [routerLink]="enterpriseRouter[7].link">
               {{'left_menu.enterprise_waiting_approve_doc' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[8].link) ? 'highlight' : '' " tabindex="0"
               class="collapse-item" [routerLink]="enterpriseRouter[8].link">
               {{'left_menu.enterprise_waiting_initial_doc' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[36].link) ? 'highlight' : '' " tabindex="0"
               class="collapse-item" [routerLink]="enterpriseRouter[36].link" *ngIf="isNotAttestedUser">
               {{'left_menu.enterprise_waiting_confirm_doc' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[29].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[29].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[29].link">{{'left_menu.enterprise_contract_digitization' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[42].link) ? 'highlight' : '' " tabindex="0" 
               *ngIf="getAccessRights(enterpriseRouter[42].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[42].link">{{'breadcrumbs.document_processing' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[43].link) ? 'highlight' : '' " tabindex="0" 
               *ngIf="getAccessRights(enterpriseRouter[43].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[43].link">{{'negotiate_contract.breadcrumb' | translate}}</a>
         </div>
      </div>
   </li>

   <!-- Nav Item - My Documents Contract -->
   <li class="nav-item no-arrow"
   *ngIf="(getAccessRights(enterpriseRouter[53].link) || getAccessRights(enterpriseRouter[54].link) || getAccessRights(enterpriseRouter[49].link) || getAccessRights(enterpriseRouter[47].link)) && entType == '1'">
   <a id="menuMyContract" (click)="onMenuClick('menuMyContract')" class="nav-link collapsed" appTrackEvent="w.menu.hdld_cua_toi"
      href="javascript:void(0)" data-toggle="collapse" data-target="#collapseMyContract" aria-expanded="true"
      aria-controls="collapseMyContract"
      [ngClass]="( currentLink == enterpriseRouter[53].link || currentLink == enterpriseRouter[54].link || currentLink == enterpriseRouter[47].link || currentLink === enterpriseRouter[49].link) ? 'active' : '' ">
      <em class="fa fa-fw fa-folder-open-o"></em>
      <span>{{'breadcrumbs.my_contracts'| translate}}</span>
   </a>
   <div id="collapseMyContract" class="collapse prioritize-submenu" aria-labelledby="headingPages"
      data-parent="#accordionHeaderSidebar">
      <div class="collapse-inner rounded">
         <a [ngClass]=" (currentLink === enterpriseRouter[47].link) ? 'highlight' : '' " tabindex="0" appTrackEvent="w.menu._hdld_sohoa_khac"
            *ngIf="getAccessRights(enterpriseRouter[47].link) && entType == '1'" class="collapse-item" 
            [routerLink]="enterpriseRouter[47].link">
         {{'left_menu.labor_contract' | translate}}</a>
         
         <a [ngClass]=" (currentLink === enterpriseRouter[49].link) ? 'highlight' : '' " tabindex="0" appTrackEvent="w.menu._hdld_sohoa"
            *ngIf="getAccessRights(enterpriseRouter[49].link) && entType == '1'" class="collapse-item" 
            [routerLink]="enterpriseRouter[49].link">
            {{'left_menu.document_moha' | translate}} </a>
         <a [ngClass]=" (currentLink === enterpriseRouter[53].link) ? 'highlight' : '' " tabindex="0" appTrackEvent="w.menu._hdld_sohoa_kyduyet"
            *ngIf="getAccessRights(enterpriseRouter[53].link) && entType == '1'" class="collapse-item" 
            [routerLink]="enterpriseRouter[53].link">
         {{'left_menu.labor_contract' | translate}}</a>
         
         <a [ngClass]=" (currentLink === enterpriseRouter[54].link) ? 'highlight' : '' " tabindex="0" appTrackEvent="w.menu._hdld_sohoa_pheduyet"
            *ngIf="getAccessRights(enterpriseRouter[54].link) && entType == '1'" class="collapse-item" 
            [routerLink]="enterpriseRouter[54].link">
            {{'left_menu.document_moha' | translate}} </a>
      </div>
      
   </div>
</li>

   <!-- QUẢN LÝ KHÁCH HÀNG -->
   <!-- Nav Item - management customer -->
   <li class="nav-item no-arrow"
      *ngIf="getAccessRights(enterpriseRouter[14].link) || getAccessRights(enterpriseRouter[32].link)">
      <a id="menuManagementCustomer" (click)="onMenuClick('menuManagementCustomer')" class="nav-link collapsed"
         href="javascript:void(0)" data-toggle="collapse" data-target="#collapseManagementCustomer" aria-expanded="true"
         aria-controls="collapseManagementCustomer"
         [ngClass]="(currentLink == enterpriseRouter[14].link || currentLink == enterpriseRouter[32].link) ? 'active' : '' ">
         <i class="fa fa-user-o fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
         <span>{{'title.management_customer' | translate}}</span>
      </a>
      <div id="collapseManagementCustomer" class="collapse prioritize-submenu" aria-labelledby="headingPages"
         data-parent="#accordionHeaderSidebar">
         <div class="collapse-inner rounded">
            <a [ngClass]=" (currentLink == enterpriseRouter[32].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[32].link) && !commonService.getIsLockedEnterprise()"
               class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[32].link">{{'title.add_customer' | translate}}</a>
            <a [ngClass]=" (currentLink == enterpriseRouter[14].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[14].link)" class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[14].link">{{'title.enterprise_customer' | translate}}</a>
            <a [ngClass]=" (currentLink == enterpriseRouter[33].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[33].link)" class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[33].link">{{'title.enterprise_group_customer' | translate}}</a>
            <a [ngClass]=" (currentLink == enterpriseRouter[34].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[34].link) && !commonService.getIsLockedEnterprise()"
               class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[34].link">{{'title.export_data_customer' |
               translate}}</a>
         </div>
      </div>
   </li>

   <!-- Nav Item - Report Management -->
   <li class="nav-item no-arrow"
      *ngIf="getAccessRights(enterpriseRouter[17].link) || getAccessRights(enterpriseRouter[18].link) || getAccessRights(enterpriseRouter[19].link)
        || getAccessRights(enterpriseRouter[20].link) || getAccessRights(enterpriseRouter[21].link) || getAccessRights(enterpriseRouter[22].link)  || getAccessRights(enterpriseRouter[45].link)">
      <a id="menuReportManage" (click)="onMenuClick('menuReportManage')" class="nav-link collapsed"
         href="javascript:void(0)" data-toggle="collapse" data-target="#collapseReport" aria-expanded="true"
         aria-controls="collapseDocuments"
         [ngClass]=" (currentLink == enterpriseRouter[17].link) || (currentLink == enterpriseRouter[18].link) || (currentLink == enterpriseRouter[19].link
                    || (currentLink == enterpriseRouter[20].link) || (currentLink == enterpriseRouter[21].link) || (currentLink == enterpriseRouter[22].link)  || (currentLink == enterpriseRouter[45].link))? 'active' : '' ">
         <i class="fa fa-line-chart fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
         <span>{{'menu_report.env_report'| translate}}</span>
      </a>
      <div id="collapseReport" class="collapse prioritize-submenu" aria-labelledby="headingPages"
         data-parent="#accordionHeaderSidebar">
         <div class="collapse-inner rounded">
            <a [ngClass]=" (currentLink === enterpriseRouter[21].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[21].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[21].link">{{'menu_report.total_contract_individual' | translate}}
            </a>
            <a [ngClass]=" (currentLink === enterpriseRouter[20].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[20].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[20].link">{{'menu_report.total_contract_company' | translate}}
            </a>
            <a [ngClass]=" (currentLink === enterpriseRouter[22].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[22].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[22].link">{{'menu_report.total_contract_take' | translate}}
            </a>
            <a [ngClass]=" (currentLink === enterpriseRouter[45].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[45].link)" class="collapse-item" 
               [routerLink]="enterpriseRouter[45].link">{{'breadcrumbs.document_processing' | translate}}
            </a>
            <a [ngClass]=" (currentLink === enterpriseRouter[17].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[17].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[17].link">{{'menu_report.total_contract_report' | translate}}
            </a>
            <a [ngClass]=" (currentLink === enterpriseRouter[18].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[18].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[18].link">{{'menu_report.total_sms' | translate}}
            </a>
            <a [ngClass]=" (currentLink === enterpriseRouter[19].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[19].link)" class="collapse-item"
               [routerLink]="enterpriseRouter[19].link">{{'menu_report.total_money_sms' | translate}}
            </a>
            <a [ngClass]=" (currentLink === enterpriseRouter[30].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[30].link) && !isNotAttestedUser" class="collapse-item"
               [routerLink]="enterpriseRouter[30].link">{{'menu_report.certificate_money_report' | translate}}
            </a>
            <a [ngClass]=" (currentLink === enterpriseRouter[31].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[31].link) && !isNotAttestedUser" class="collapse-item"
               [routerLink]="enterpriseRouter[31].link">{{'menu_report.timestamp_quantity_report' | translate}}
            </a><a [ngClass]=" (currentLink === enterpriseRouter[38].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[38].link) " class="collapse-item"
               [routerLink]="enterpriseRouter[38].link">{{'menu_report.number_of_contract_user' | translate}}
            </a>
         </div>
      </div>

   </li>

   <!-- THÔNG TIN DOANH NGHIỆP -->
   <!-- Nav Item - Enterprise Info -->

   <li class="nav-item no-arrow" *ngIf="getAccessRights(enterpriseRouter[9].link) || getAccessRights(enterpriseRouter[11].link) || getAccessRights(enterpriseRouter[28].link)
         || getAccessRights(enterpriseRouter[12].link) || getAccessRights(enterpriseRouter[13].link)">
      <a id="menuEnterpriseInfo" (click)="onMenuClick('menuEnterpriseInfo')" class="nav-link collapsed"
         href="javascript:void(0)" data-toggle="collapse" data-target="#collapseEnterpriseInfo" aria-expanded="true"
         aria-controls="collapseEnterpriseInfo"
         [ngClass]=" (currentLink == enterpriseRouter[9].link || currentLink == enterpriseRouter[11].link
            || currentLink == enterpriseRouter[13].link || currentLink == enterpriseRouter[12].link || currentLink == enterpriseRouter[28].link) ? 'active' : '' ">
         <i class="fa fa-building-o fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
         <span>{{'title.enterprise_manage' | translate}}</span>
      </a>
      <div id="collapseEnterpriseInfo" class="collapse prioritize-submenu" aria-labelledby="headingPages"
         data-parent="#accordionHeaderSidebar">
         <div class="collapse-inner rounded">
            <a [ngClass]=" (currentLink == enterpriseRouter[9].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[9].link)" class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[9].link">{{'title.enterprise_info' | translate}}</a>
            <a (click)="eventCheckPermissionBranch()"
               [ngClass]=" (currentLink == enterpriseRouter[11].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[11].link) && isDisplayMenuManageBranch" class="collapse-item"
               href="javascript:void(0)">{{'title.branch' | translate}}</a>
            <a [ngClass]=" (currentLink == enterpriseRouter[28].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[28].link)" class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[28].link">{{'title.department' | translate}}</a>
            <a [ngClass]=" (currentLink == enterpriseRouter[12].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[12].link)" class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[12].link">{{'left_menu.enterprise_groupuser' | translate}}</a>
            <a [ngClass]=" (currentLink == enterpriseRouter[13].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[13].link)" class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[13].link">{{'title.enterprise_user' | translate}}</a>
         </div>
      </div>
   </li>

   <!-- CẤU HÌNH CHUNG -->
   <!-- Nav Item - General Config -->

   <li class="nav-item no-arrow"
      *ngIf="getAccessRights(enterpriseRouter[10].link) || getAccessRights(enterpriseRouter[25].link) || getAccessRights(enterpriseRouter[15].link)
         || getAccessRights(enterpriseRouter[23].link) || getAccessRights(enterpriseRouter[24].link) || getAccessRights(enterpriseRouter[35].link) || getAccessRights(enterpriseRouter[39].link)">
      <a id="menuGeneralConfig" (click)="onMenuClick('menuGeneralConfig')" class="nav-link collapsed"
         href="javascript:void(0)" data-toggle="collapse" data-target="#collapseGeneralConfig" aria-expanded="true"
         aria-controls="collapseGeneralConfig"
         [ngClass]=" (currentLink == enterpriseRouter[10].link || currentLink == enterpriseRouter[25].link
            || currentLink == enterpriseRouter[15].link || currentLink == enterpriseRouter[23].link || currentLink == enterpriseRouter[24].link || currentLink == enterpriseRouter[35].link || currentLink == enterpriseRouter[39].link) ? 'active' : '' ">
         <i class="fa fa-cog fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
         <span>{{'title.general_config' | translate}}</span>
      </a>
      <div id="collapseGeneralConfig" class="collapse prioritize-submenu" aria-labelledby="headingPages"
         data-parent="#accordionHeaderSidebar">
         <div class="collapse-inner rounded">
            <a tabindex="0" [ngClass]=" (currentLink == enterpriseRouter[23].link) ? 'highlight' : '' "
               class="collapse-item" href="javascript:void(0)" *ngIf="getAccessRights(enterpriseRouter[23].link)"
               [routerLink]="enterpriseRouter[23].link">{{'title.document_management_list' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[15].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[15].link)" class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[15].link">{{'title.contract_types' | translate}}</a>
            <a [ngClass]=" (currentLink === enterpriseRouter[25].link) ? 'highlight' : '' " tabindex="0"
               *ngIf="getAccessRights(enterpriseRouter[25].link)" class="collapse-item" href="javascript:void(0)"
               [routerLink]="enterpriseRouter[25].link">{{'title.procedure_management_enteprise' | translate}}</a>
            <a [ngClass]=" (currentLink == enterpriseRouter[10].link) ? 'highlight' : '' " tabindex="0"
               class="collapse-item" href="javascript:void(0)" *ngIf="getAccessRights(enterpriseRouter[10].link)"
               [routerLink]="enterpriseRouter[10].link">{{'left_menu.as-certificate' | translate}}</a>
            <a tabindex="0" [ngClass]=" (currentLink == enterpriseRouter[24].link) ? 'highlight' : '' "
               class="collapse-item" href="javascript:void(0)" *ngIf="getAccessRights(enterpriseRouter[24].link)"
               [routerLink]="enterpriseRouter[24].link">{{'title.general_category' | translate}}</a>
            <a tabindex="0" [ngClass]=" (currentLink == enterpriseRouter[35].link) ? 'highlight' : '' "
               class="collapse-item" href="javascript:void(0)" *ngIf="getAccessRights(enterpriseRouter[35].link)"
               [routerLink]="enterpriseRouter[35].link">{{'title.enterprise_config' | translate}}</a>
            <a tabindex="0" [ngClass]=" (currentLink == enterpriseRouter[39].link) ? 'highlight' : '' "
               class="collapse-item" href="javascript:void(0)" *ngIf="getAccessRights(enterpriseRouter[39].link)"
               [routerLink]="enterpriseRouter[39].link">{{'config_notification.left_menu' | translate}}</a>
         </div>
      </div>
   </li>

   <!-- Thay đổi mật khẩu -->
   <li class="nav-item no-arrow">
      <a class="nav-link" href="javascript:void(0)" (click)="changePassword()">
         <i class="fa fa-lock fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
         <span>{{'header.change_password' | translate}}</span>
      </a>
   </li>

   <!-- Đăng xuất -->
   <li class="nav-item no-arrow">
      <a class="nav-link" href="javascript:void(0)" (click)="logout()">
         <i class="fa fa-sign-out fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
         <span>{{'header.logout' | translate}}</span>
      </a>
   </li>
</ul>
